export default __webpack_public_path__ + "static/badge-do-2-bold-dark-38822cf7ea60da389ceeb3685b2363ce55ce104aa387551bb76c34758e7e5c09.png";